module.exports = __webpack_public_path__ + "static/media/SWAMP-BUSD.b6af22f9.svg";